// extracted by mini-css-extract-plugin
export default {"container":"_1_m3M","dot":"_1jqCz","opacitychange":"ERm3Q"};